import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import EditSliderComponent from '../components/EditSliderComponent';
import HeaderComponent from '../components/HeaderComponent';

class EditSliderPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <EditSliderComponent id={this.props.match.params.id}/>
            </div>
        );
    }
}

export default EditSliderPage;